import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import TextFieldComponent from '../../../components/TextFieldComponent';

import zod from 'zod';
import { ResponsibleFormSchema } from '../../../services/ResponsibleService/schemas';
import { Grid2 } from '@mui/material';
import { zodResolver } from '@hookform/resolvers/zod';
import ButtonComponent from '../../../components/ButtonComponent';

import { AppContext } from '../../../context/AppContextProvider';
import ModalComponent from '../../../components/ModalComponent';

import DropdownSelectComponent from '../../../components/DropdownSelectComponent';
import { useGetAllStudentByLicenseMutateAsync } from '../../../services/StudentService/hooks/useMutation';
import { IStudentSimpleProps } from '../../../services/StudentService/types';

import {
  useCreateSchoolTransportationAsync,
  useUpdateSchoolTransportationAsync,
} from '../../../services/SchoolTransportation/hooks/useMutation';
import { SchoolTransportationFormSchema } from '../../../services/SchoolTransportation/schemas';
import { SchoolTicketViewSchema } from '../../../services/SchoolTicket/schemas';
import { getAllStudentsByLicenseAsync } from '../../../services/Recognition/Student';
import { useGetAllStudentsByLicenseMutateAsync } from '../../../services/Recognition/Student/hooks/useMutation';
import { IStudentRecognitionSimpleProps } from '../../../services/Recognition/Student/types';

export type SchoolTicketFormInput = zod.infer<typeof SchoolTicketViewSchema>;

interface SchoolTicketEditionModalProps {
  isOpen: boolean;
  responsibleEdit?: any;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  handleSaveForm?: () => void;
  handleClose?: () => void;
}

const SchoolTicketEditionModal = ({
  isOpen,
  setIsOpen,
  responsibleEdit,
  handleClose,
  handleSaveForm,
}: SchoolTicketEditionModalProps) => {
  const [isDeviceSelected, setIsDeviceSelected] = useState<boolean>(false);
  const form = useForm<SchoolTicketFormInput>({
    resolver: zodResolver(SchoolTicketViewSchema),
    defaultValues: {
      cpf: '',
      name: '',
    },
  });
  const {
    control,
    watch,
    getValues,
    handleSubmit,
    formState: { errors },
    reset,
  } = form;
  const { showSnackbar } = useContext(AppContext);

  const [students, setStudents] = useState<IStudentRecognitionSimpleProps[]>(
    [],
  );

  const {
    mutate: mutateCreateSchoolTransportation,
    isLoading: isLoadingCreateResponsible,
  } = useCreateSchoolTransportationAsync();
  const { mutateAsync: mutateGetAllStudentByLicenseAsync } =
    useGetAllStudentsByLicenseMutateAsync();
  const { mutate: mutateUpdate, isLoading: isLoadingUpdateResponsible } =
    useUpdateSchoolTransportationAsync();

  useEffect(() => {
    if (responsibleEdit) {
      reset(responsibleEdit, { keepDefaultValues: true });
    }
  }, [responsibleEdit]);

  const handleSave = (data: any) => {
    if (data.id) {
      mutateUpdate(
        {
          data,
          id: data.id,
        },
        {
          onSuccess: () => {
            resetAllAndShowMessage(
              'Transporte escolar atualizado com sucesso.',
            );
          },
        },
      );
      return;
    }

    mutateCreateSchoolTransportation(
      {
        data,
      },
      {
        onSuccess: () => {
          resetAllAndShowMessage('Transporte escolar cadatrado com sucesso.');
        },
        onError() {
          showSnackbar('Erro ao cadastrar Transporte escolar.', 'error');
        },
      },
    );
  };

  const resetAllAndShowMessage = (message: string) => {
    if (handleSaveForm) handleSaveForm();
    showSnackbar(message, 'success');
    reset();
    setIsOpen(false);
  };

  const onCloseModal = () => {
    setIsOpen(false);
    if (handleClose) handleClose();
    reset();
  };

  useEffect(() => {
    mutateGetAllStudentByLicenseAsync(undefined).then(setStudents);
  }, []);

  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onCloseModal}
      title={'Edição de Ticket Escolar'}
    >
      <Grid2
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        sx={{ mt: 2 }}
      >
        <Grid2 size={isDeviceSelected ? 12 : 6}>
          <Controller
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <TextFieldComponent
                label="Nome"
                value={value}
                errorMessage={error?.message}
                onChangeText={onChange}
              />
            )}
            name={'name'}
            control={control}
          />
        </Grid2>
        {/*<Grid2 size={6}>*/}
        {/*  <Controller*/}
        {/*    render={({ field: { value, onChange }, fieldState: { error } }) => (*/}
        {/*      <DropdownSelectComponent*/}
        {/*        label="Alunos"*/}
        {/*        selectedValues={value as any[]}*/}
        {/*        onSelectedValues={onChange}*/}
        {/*        options={students}*/}
        {/*        labelField={'name'}*/}
        {/*        valueField={'id'}*/}
        {/*      />*/}
        {/*    )}*/}
        {/*    name={'cpf'}*/}
        {/*    control={control}*/}
        {/*  />*/}
        {/*</Grid2>*/}
      </Grid2>
      <ButtonComponent
        fullWidth
        sx={{ mt: 3 }}
        onClick={handleSubmit(handleSave)}
        loading={isLoadingCreateResponsible || isLoadingUpdateResponsible}
      >
        Salvar
      </ButtonComponent>
    </ModalComponent>
  );
};

export default SchoolTicketEditionModal;
